import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=d7d81534&scoped=true&"
import script from "./registry.ts?vue&type=script&lang=ts&"
export * from "./registry.ts?vue&type=script&lang=ts&"
import style0 from "./registry.scss?vue&type=style&index=0&id=d7d81534&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d81534",
  null
  
)

export default component.exports